import Body from "./Content";

export default Body;
